<div class="tt-o-media-thumb" :style="itemStyles">
  <div v-if="!isImageLoaded" class="tt-o-spinner tt-o-media-thumb__spinner"></div>
  <img v-show="isImageLoaded" :src="imageSrc" @load="onImageLoad" class="tt-o-media-thumb__image" :style="imageStyles" :alt="altText">
  <time v-if="this.media.durationFormatted" class="tt-o-media-thumb__video-timestamp" :style="durationScaling">{{ this.media.durationFormatted }}</time>
</div>
